import { useQuery } from '@apollo/client';
import { T1, ALL_SHARD_MODULES, NEW_MODULE_MAP } from '@nile/components';
import { AccountClient, GET_FIELD } from '@nile/graphql';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  Popover,
  Button,
  ButtonGroup,
  RadioButton
} from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState, useEffect } from 'react';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const CustomField = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;

const Label = styled.div`
  text-align: left;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 10px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;

function AsyncRadio(props) {
  const {
    field,
    ticket,
    defaultValue,
    updateSelection,
    editable,
    value,
    inlineEdit,
    disableSelection
  } = props;
  const { data, loading, error } = useQuery(GET_FIELD, {
    client: AccountClient,
    variables: {
      input: {
        columnName: field?.columnName || field?.name,
        entity:
          NEW_MODULE_MAP[props?.module] ||
          ALL_SHARD_MODULES[props?.module] ||
          ALL_SHARD_MODULES.ticket
      }
    }
  });
  const updateSelectedField = (checked, newValue) => {
    updateSelection(newValue);
  };
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const [updatedValue, setUpdatedValue] = useState(value || '');
  useEffect(() => {
    if (!isEqual(updatedValue, value)) {
      setUpdatedValue(value);
    }
  }, [value]);
  const updateUpdatedValue = (val) => {
    setUpdatedValue(val);
  };
  if (loading) return <div>loading...</div>;
  const displayVal = value;
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;
  const getTag = () => {
    return (
      <CustomField className="cf-wrapper">
        <Label className="cf-label">{field.label || ''}</Label>
        <div className="flex col" key={field.name}>
          {data.getField.options.map((item) => {
            return (
              <RadioButton
                disabled={disableSelection}
                label={item?.value}
                id={`radio-${item?.value}-${field.columnName || field.name}`}
                name={`radio-${item?.value}-${field.columnName || field.name}`}
                checked={updatedValue === item?.value}
                onChange={() => updateUpdatedValue(item?.value)}
              />
            );
          })}
        </div>
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedValue('');
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                updateSelectedField('', updatedValue);
                togglePopoverActive();
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </CustomField>
    );
  };
  if (inlineEdit) {
    return !popoverActive ? (
      <CField>
        <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
          <div className="ellipsis" title={displayVal}>
            {displayVal || <DisabledTag>NA</DisabledTag>}
          </div>
          {editable && <div className="edit-actions">{activator}</div>}
        </Wrap>
      </CField>
    ) : (
      <CField>
        <Wrap className="editable-cell">
          <div className="ellipsis" title={displayVal}>
            {displayVal || <DisabledTag>NA</DisabledTag>}
          </div>
          <Popover
            activator={activator}
            active={popoverActive}
            onClose={() => {
              // togglePopoverActive()
            }}
          >
            {getTag()}
          </Popover>
        </Wrap>
      </CField>
    );
  }
  return (
    <CustomField className="cf-wrapper">
      <Label className="cf-label">
        <T1>{field.label || ''}</T1>
      </Label>
      <div className="flex col" key={field.name}>
        {data.getField.options.map((item) => {
          return (
            <RadioButton
              label={item?.value}
              id={`radio-${item?.value}-${field.columnName}`}
              name={`radio-${item?.value}-${field.columnName}`}
              checked={value === item?.value}
              onChange={() => updateSelection(item?.value)}
              disabled={disableSelection}
            />
          );
        })}
      </div>
    </CustomField>
  );
}

export default AsyncRadio;
